(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bl-behavior"] && !Shopify.designMode) return;
  try {
    (()=>{
const dict=JSON.parse(document.getElementById('bl-translations').textContent);
const ctx=JSON.parse(document.getElementById('bl-context').textContent);
const supported=Object.keys(dict), query=new URLSearchParams(location.search);
const storage={get(k){try{return localStorage.getItem(k)}catch{return null}},set(k,v){try{localStorage.setItem(k,v)}catch{}}};
const manual=storage.get('bl-language'), explicit=query.get('bl_lang');
if(supported.includes(explicit))storage.set('bl-language',explicit);
const routeLang=ctx.locale.split('-')[0];
const browserLang=(navigator.languages||[navigator.language]).map(l=>l.toLowerCase().split('-')[0]).find(l=>supported.includes(l));
/* Visitors in Germany, France or Spain get German, French or Spanish by IP; a manual choice or a localized URL always wins. */
const isBot=/bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent);
const forcedGeo=(query.get('bl_geo')||'').toUpperCase(),cachedGeo=storage.get('bl-geo-country');
function geoLang(country){
 if(!country)return null;
 const direct={DE:'de',AT:'de',LI:'de',FR:'fr',MC:'fr',ES:'es'}[country];if(direct)return direct;
 if(['CH','BE','LU'].includes(country))return ['de','fr'].includes(browserLang)?browserLang:(country==='CH'?'de':'fr');
 return null;
}
const ipLang=isBot?null:geoLang(forcedGeo||cachedGeo);
let current=supported.includes(explicit)?explicit:supported.includes(manual)?manual:routeLang!=='en'&&supported.includes(routeLang)?routeLang:ipLang||browserLang||'en';
function translate(lang){
 current=lang;document.documentElement.lang=lang;document.documentElement.dataset.blLang=lang;
 document.querySelectorAll('[data-bl-t]').forEach(el=>{const value=dict[lang][el.dataset.blT];if(value)el.textContent=value});
 document.querySelectorAll('[data-bl-language-label]').forEach(el=>el.textContent=lang.toUpperCase());
 const select=document.getElementById('bl-language');if(select)select.value=lang;
 document.querySelectorAll('[data-bl-aria]').forEach(el=>{const value=dict[lang][el.dataset.blAria];if(value)el.setAttribute('aria-label',value+(el.dataset.blImageIndex?' '+el.dataset.blImageIndex:''))});
 document.querySelectorAll('[data-bl-alt]').forEach(el=>{const value=dict[lang][el.dataset.blAlt];if(value)el.alt=value});
 document.querySelectorAll('[data-bl-product-title]').forEach(el=>el.setAttribute('aria-label',dict[lang].view_images+': '+dict[lang][el.dataset.blProductTitle]));
 const heading=document.querySelector('h1[data-bl-t]');if(heading)document.title=heading.textContent+' | BasisLab';
}
function t(key){return dict[current][key]||dict.en[key]||key}
translate(current);
function localizedURL(a){
 const url=new URL(a.href,location.origin);
 if(url.origin!==location.origin||url.pathname.startsWith('/checkout')||url.pathname.startsWith('/policies'))return;
 const preview=query.get('preview_theme_id');
 if(preview)url.searchParams.set('preview_theme_id',preview);
 url.searchParams.set('bl_lang',current);
 a.href=url.href;
}
document.addEventListener('click',e=>{const link=e.target.closest('a[href]');if(link&&link.getAttribute('href').startsWith('#')===false&&!link.getAttribute('href').startsWith('mailto:'))localizedURL(link)});
const select=document.getElementById('bl-language');
if(select)select.addEventListener('change',e=>{
 const lang=e.target.value;storage.set('bl-language',lang);translate(lang);
 const url=new URL(location.href);url.searchParams.set('bl_lang',lang);history.replaceState(null,'',url);
 syncNativeLocale(lang);
});
function syncNativeLocale(lang){
 if(!ctx.design && !isBot && ctx.published.includes(lang) && routeLang!==lang){
 const url=new URL(location.href);url.searchParams.set('bl_lang',lang);
 const form=document.createElement('form');form.method='post';form.action='/localization';
 for(const [name,value] of Object.entries({form_type:'localization',_method:'put',language_code:lang,return_to:url.pathname+url.search})){const input=document.createElement('input');input.type='hidden';input.name=name;input.value=value;form.appendChild(input)}
 document.body.appendChild(form);form.submit();
 }
}
syncNativeLocale(current);
if(!manual&&!explicit&&!forcedGeo&&!cachedGeo&&!isBot&&routeLang==='en'&&!ctx.design){
 const root=ctx.root.endsWith('/')?ctx.root:ctx.root+'/';
 fetch(root+'browsing_context_suggestions.json?country[enabled]=true&language[enabled]=true')
 .then(r=>r.ok?r.json():Promise.reject())
 .then(data=>{
  const country=data.detected_values?.country?.handle||data.suggestions?.[0]?.parts?.country?.handle;
  if(!country)return;
  storage.set('bl-geo-country',country);
  const lang=geoLang(country);
  if(lang&&lang!==current&&!storage.get('bl-language')){translate(lang);syncNativeLocale(lang)}
 }).catch(()=>{});
}
document.querySelectorAll('[data-bl-filter]').forEach(button=>button.addEventListener('click',()=>{
 const section=button.closest('section');
 section.querySelectorAll('[data-bl-filter]').forEach(b=>{const active=b===button;b.classList.toggle('is-active',active);b.setAttribute('aria-pressed',String(active))});
 section.querySelectorAll('[data-bl-category]').forEach(card=>card.hidden=button.dataset.blFilter!=='all'&&card.dataset.blCategory!==button.dataset.blFilter);
}));
function initGalleries(root=document){
 root.querySelectorAll('[data-bl-card-gallery]').forEach(card=>{
  if(card.dataset.blReady)return;card.dataset.blReady='true';
  const surface=card.querySelector('[data-bl-flip]'),dots=[...card.querySelectorAll('[data-bl-card-frame]')];
  let chosen=0;
  const count=card.querySelector('[data-bl-card-count]');
  const show=frame=>{surface.dataset.frame=String(frame);if(count)count.textContent=(frame+1)+'/'+(dots.length||2);dots.forEach((b,i)=>b.setAttribute('aria-pressed',String(frame===i)))};
  surface.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'&&matchMedia('(hover:hover)').matches)show(1)});
  surface.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse')show(chosen)});
  surface.addEventListener('keydown',e=>{if(['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();chosen=1-Number(surface.dataset.frame);show(chosen)}});
  dots.forEach((button,i)=>button.addEventListener('click',()=>{chosen=i;show(i)}));
  let start=null,swiped=false;
  surface.addEventListener('touchstart',e=>{const p=e.touches[0];start={x:p.clientX,y:p.clientY};swiped=false},{passive:true});
  surface.addEventListener('touchend',e=>{if(!start)return;const p=e.changedTouches[0],dx=p.clientX-start.x,dy=p.clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){chosen=1-Number(surface.dataset.frame);show(chosen);swiped=true}start=null},{passive:true});
  surface.addEventListener('click',e=>{if(swiped){e.preventDefault();e.stopImmediatePropagation();swiped=false}},true);
 });
 root.querySelectorAll('.bl-gallery').forEach(gallery=>{
  if(gallery.dataset.blReady)return;gallery.dataset.blReady='true';
  const main=gallery.querySelector('[data-bl-main-image]'),buttons=[...gallery.querySelectorAll('[data-bl-image]')],counter=gallery.querySelector('[data-bl-gallery-count]');
  if(!main||!buttons.length)return;let index=0,start=null,swiped=false;
  const shown=()=>buttons.filter(b=>!b.hidden);
  const show=n=>{const list=shown();index=(n+list.length)%list.length;const b=list[index];main.src=b.dataset.blImage;main.dataset.blAlt=b.dataset.blImageAltKey||'image_detail';main.alt=t(main.dataset.blAlt);buttons.forEach(el=>el.setAttribute('aria-pressed',String(el===b)));if(counter)counter.textContent=(index+1)+' / '+list.length;};
  buttons.forEach(button=>button.addEventListener('click',()=>show(shown().indexOf(button))));
  gallery.addEventListener('bl:images',()=>{const b=buttons.find(el=>el.getAttribute('aria-pressed')==='true');if(!b||b.hidden)show(0);else if(counter)counter.textContent=(shown().indexOf(b)+1)+' / '+shown().length});
  if(counter)counter.textContent='1 / '+shown().length;
  gallery.querySelectorAll('[data-bl-gallery-next]').forEach(b=>b.addEventListener('click',()=>show(index+1)));
  gallery.querySelectorAll('[data-bl-gallery-prev]').forEach(b=>b.addEventListener('click',()=>show(index-1)));
  gallery.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();show(index+(e.key==='ArrowRight'?1:-1))}});
  const surface=gallery.querySelector('[data-bl-gallery-swipe]');
  surface.addEventListener('touchstart',e=>{const p=e.touches[0];start={x:p.clientX,y:p.clientY};swiped=false},{passive:true});
  surface.addEventListener('touchend',e=>{if(!start)return;const p=e.changedTouches[0],dx=p.clientX-start.x,dy=p.clientY-start.y;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.5){show(index+(dx<0?1:-1));swiped=true}start=null},{passive:true});
  surface.addEventListener('click',e=>{if(swiped){e.preventDefault();e.stopImmediatePropagation();swiped=false}},true);
 });
}
initGalleries();
document.addEventListener('shopify:section:load',e=>initGalleries(e.target));

/* Product forms are delegated so they keep working after the formula picker swaps the product in place.
   bl:adding / bl:added / bl:add-error let the sticky bar follow along. */
document.addEventListener('submit',async e=>{
 const form=e.target;if(!form.matches||!form.matches('.bl-product-form'))return;
 e.preventDefault();const button=form.querySelector('button[type=submit]'),status=form.querySelector('[role=status]');
 if(button.disabled)return;
 const label=button.querySelector('[data-bl-t]');button.disabled=true;label.textContent=t('adding');status.textContent='';
 form.dispatchEvent(new CustomEvent('bl:adding',{bubbles:true}));
 try{
 const data=new FormData(form);
 const root=ctx.root.endsWith('/')?ctx.root:ctx.root+'/';
 const result=await fetch(root+'cart/add.js',{method:'POST',body:data,headers:{Accept:'application/json'}});
 if(!result.ok)throw new Error('cart');
 const cart=await fetch(root+'cart.js',{headers:{Accept:'application/json'}}).then(r=>r.json());
 document.querySelectorAll('.bl-cart-count').forEach(el=>el.textContent=cart.item_count);
 status.textContent=t('added')+' ';const link=document.createElement('a');link.href=root+'cart';link.textContent=t('viewbag');status.appendChild(link);
 form.dispatchEvent(new CustomEvent('bl:added',{bubbles:true,detail:{cart}}));
 }catch{status.textContent=t('error');form.dispatchEvent(new CustomEvent('bl:add-error',{bubbles:true}))}
 finally{button.disabled=false;label.textContent=t('add')}
});
if(ctx.role!=='main'){
 document.documentElement.style.setProperty('--bl-offer-bottom','80px');
 const badge=document.createElement('div');badge.className='bl-review-badge';badge.dataset.blT='review';badge.textContent=t('review');document.body.appendChild(badge);
}

const welcome=document.getElementById('bl-welcome');
if(welcome){
 const demo=welcome.dataset.preview==='true',live=welcome.dataset.live==='true';
 const key=demo?'bl-welcome-preview':'bl-welcome';
 const successKey=key+'-joined',closedKey=key+'-closed';
 const days=Number(welcome.dataset.frequency)||7;
 const canAuto=()=>!storage.get(successKey)&&Date.now()-Number(storage.get(closedKey)||0)>days*86400000;
 let opener=null,autoDone=false;
 const openWelcome=(manual=false)=>{
  if(welcome.open||(!demo&&!live))return;
  if(!manual){
   if(autoDone||!canAuto()||location.pathname.includes('/cart')||document.visibilityState!=='visible')return;
   const consent=document.getElementById('shopify-pc__banner');
   if(consent&&consent.getBoundingClientRect().height>0)return;
   if(document.activeElement?.matches('input,select,textarea')||document.querySelector('.bl-add:disabled'))return;
   autoDone=true;
  }
  opener=document.activeElement;welcome.showModal();
 };
 const closeWelcome=()=>{welcome.close();storage.set(closedKey,String(Date.now()));if(opener?.focus)opener.focus()};
 document.addEventListener('click',e=>{if(e.target.closest&&e.target.closest('[data-bl-newsletter-open]'))openWelcome(true)});
 document.querySelectorAll('[data-bl-newsletter-close]').forEach(b=>b.addEventListener('click',closeWelcome));
 welcome.addEventListener('cancel',e=>{e.preventDefault();closeWelcome()});
 welcome.addEventListener('click',e=>{if(e.target===welcome){const r=welcome.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)closeWelcome()}});
 const signup=document.getElementById('bl-newsletter-form');
 if(signup)signup.addEventListener('submit',e=>{
  if(!signup.reportValidity()){e.preventDefault();return}
  if(demo){
   e.preventDefault();storage.set(successKey,'1');
   welcome.querySelector('[data-bl-signup-content]').hidden=true;
   welcome.querySelector('[data-bl-signup-complete]').hidden=false;
   welcome.querySelector('[data-bl-success-heading]').focus();
  }else if(!live){e.preventDefault()}
  else {const interest=signup.querySelector('input[name=bl_interest]:checked')?.value||'both';signup.querySelector('input[name="contact[tags]"]').value='newsletter,basislab-eu,interest-'+interest+',lang-'+current}
 });
 if(document.querySelector('[data-bl-signup-success]')){storage.set(successKey,'1');openWelcome(true)}
 if(document.querySelector('[data-bl-signup-errors]'))openWelcome(true);
 const share=(Number(welcome.dataset.scroll)||33)/100;
 const scrolled=()=>{const max=document.documentElement.scrollHeight-innerHeight;return max>0&&scrollY/max>=share};
 let eligible=false;
 document.addEventListener('scroll',()=>{if(!eligible&&scrolled())eligible=true;if(eligible)openWelcome()},{passive:true});
 document.addEventListener('visitorConsentCollected',()=>{if(eligible)openWelcome()});
 if(query.get('bl_offer')==='preview')openWelcome(true);
}

document.addEventListener('shopify:section:load',()=>translate(current));
})();


/* Local switch only: no cart, subscription or navigation side effects. */
(()=>{
 const init=(root=document)=>root.querySelectorAll('[data-bl-ritual]').forEach(group=>{
  if(group.dataset.blRitualReady)return;
  group.dataset.blRitualReady='true';
  group.querySelectorAll('[data-bl-ritual-select]').forEach(button=>button.addEventListener('click',()=>{
   const format=button.dataset.blRitualSelect;
   group.querySelectorAll('[data-bl-ritual-select]').forEach(tab=>tab.setAttribute('aria-pressed',String(tab===button)));
   group.querySelectorAll('[data-bl-ritual-panel]').forEach(panel=>panel.hidden=panel.dataset.blRitualPanel!==format);
  }));
 });
 init();document.addEventListener('shopify:section:load',event=>init(event.target));
})();
/* bl-ugc start */
(()=>{
const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const initUgc=(root=document)=>{
root.querySelectorAll('[data-bl-ugc]').forEach(section=>{
 if(section.dataset.blUgcReady)return;section.dataset.blUgcReady='1';
 const track=section.querySelector('[data-bl-ugc-track]'),videos=[...section.querySelectorAll('video')];
 const load=v=>{if(!v.src&&v.dataset.src){v.src=v.dataset.src}};
 const io=new IntersectionObserver(entries=>entries.forEach(e=>{const v=e.target;if(e.isIntersecting&&e.intersectionRatio>.6){load(v);if(!reduce)v.play().catch(()=>{})}else{v.pause()}}),{threshold:[0,.6,1]});
 videos.forEach(v=>io.observe(v));
 section.querySelectorAll('[data-bl-ugc-sound]').forEach(btn=>btn.addEventListener('click',()=>{
  const v=btn.closest('.bl-ugc-frame').querySelector('video'),on=v.muted;
  document.querySelectorAll('[data-bl-ugc] video').forEach(o=>{o.muted=true;o.closest('.bl-ugc-frame').querySelector('[data-bl-ugc-sound]').setAttribute('aria-pressed','false')});
  load(v);v.muted=!on;btn.setAttribute('aria-pressed',String(on));if(on)v.play().catch(()=>{});
 }));
 section.querySelectorAll('video').forEach(v=>v.addEventListener('click',()=>{load(v);v.paused?v.play().catch(()=>{}):v.pause()}));
 const step=()=>(track.querySelector('.bl-ugc-card')?.offsetWidth||232)+16;
 section.querySelector('[data-bl-ugc-prev]')?.addEventListener('click',()=>track.scrollBy({left:-step()*2,behavior:'smooth'}));
 section.querySelector('[data-bl-ugc-next]')?.addEventListener('click',()=>track.scrollBy({left:step()*2,behavior:'smooth'}));
});
root.querySelectorAll('[data-bl-tt]').forEach(section=>{
 if(section.dataset.blTtReady)return;section.dataset.blTtReady='1';
 const i18n=JSON.parse(section.querySelector('[data-bl-tt-i18n]').textContent),kind=section.dataset.kind;
 const ui={en:['See translation','See original'],fr:['Voir la traduction','Voir l’original'],de:['Übersetzung anzeigen','Original anzeigen'],es:['Ver traducción','Ver original'],nl:['Vertaling tonen','Origineel tonen']};
 let cards=[...section.querySelectorAll('.bl-tt-card')];
 if(kind==='peel'||kind==='mask'){cards.forEach(c=>{if(c.dataset.kind!==kind)c.remove()});cards=[...section.querySelectorAll('.bl-tt-card')]}
 const count=section.querySelector('[data-bl-tt-count]');if(count)count.textContent=cards.length;
 if(!cards.length){section.hidden=true;return}
 const render=()=>{const lang=(document.documentElement.dataset.blLang||document.documentElement.lang||'en').slice(0,2);
  cards.forEach(c=>{const p=c.querySelector('.bl-tt-text'),btn=c.querySelector('[data-bl-tt-toggle]'),tr=(i18n[c.dataset.review]||{})[lang];
   const label=ui[lang]||ui.en;
   if(c.getAttribute('lang')===lang||!tr){p.textContent=p.dataset.original;btn.hidden=true;return}
   c.dataset.mode='tr';p.textContent=tr;btn.hidden=false;btn.textContent=label[1];
   btn.onclick=()=>{const o=c.dataset.mode==='tr';c.dataset.mode=o?'orig':'tr';p.textContent=o?p.dataset.original:tr;btn.textContent=o?label[0]:label[1]}});};
 render();new MutationObserver(render).observe(document.documentElement,{attributes:true,attributeFilter:['lang','data-bl-lang']});
 const per=window.innerWidth<750?4:9;let visible=per;const more=section.querySelector('[data-bl-tt-more]');
 const page=()=>{cards.forEach((c,i)=>c.hidden=i>=visible);if(more)more.parentElement.hidden=visible>=cards.length};
 page();more?.addEventListener('click',()=>{visible+=per;page()});
});
};
initUgc();
document.addEventListener('shopify:section:load',e=>initUgc(e.target));
})();
/* bl-ugc end */
/* bl-sub start */
(()=>{
const dict=JSON.parse(document.getElementById('bl-translations').textContent);
const ctx=JSON.parse(document.getElementById('bl-context').textContent);
const root=ctx.root.endsWith('/')?ctx.root:ctx.root+'/';
const t=k=>{const l=(document.documentElement.dataset.blLang||document.documentElement.lang||'en').slice(0,2);return (dict[l]||dict.en)[k]||dict.en[k]||k};
const store=s=>({get(k){try{return s.getItem(k)}catch{return null}},set(k,v){try{s.setItem(k,v)}catch{}}});
const ls=store(window.localStorage),ss=store(window.sessionStorage);
const SUB_CODE='SUB15',OURS=()=>[SUB_CODE,ls.get('bl-welcome-code')].filter(Boolean).map(c=>c.toUpperCase());
const api=(u,o={})=>fetch(root+u,{...o,headers:{Accept:'application/json','Content-Type':'application/json'}}).then(r=>{if(!r.ok)throw new Error(u);return r.json()});

/* Keep SUB15 on carts with subscription lines and the welcome code on carts with one-time lines. */
async function syncCodes(){
 const cart=await api('cart.js');
 if(!cart.items.length)return {cart,changed:false};
 const want=[];
 if(cart.items.some(i=>i.selling_plan_allocation))want.push(SUB_CODE);
 const w=ls.get('bl-welcome-code');if(w&&cart.items.some(i=>!i.selling_plan_allocation))want.push(w.toUpperCase());
 const have=(cart.discount_codes||[]).map(d=>d.code.toUpperCase());
 const next=[...new Set([...have.filter(c=>!OURS().includes(c)),...want])];
 if(next.length===have.length&&next.every(c=>have.includes(c)))return {cart,changed:false};
 try{return {cart:await api('cart/update.js',{method:'POST',body:JSON.stringify({discount:next.join(',')})}),changed:true}}
 catch{if(want[0])await fetch(root+'discount/'+encodeURIComponent(want[0])+'?redirect=%2Fcart.js');return {cart,changed:true}}
}
const nativeFetch=window.fetch;
window.fetch=function(input,init){const p=nativeFetch.apply(this,arguments);try{const u=String(input&&input.url||input);if(/\/cart\/add(\.js)?(\?|$)/.test(u))p.then(r=>{if(r.ok)setTimeout(()=>syncCodes().catch(()=>{}),60)})}catch{}return p};

/* Purchase options: the hidden selling_plan input is only sent for subscriptions. */
const setPurchase=(fs,mode)=>{const radio=fs.querySelector(`input[name=bl_purchase][value=${mode}]`);if(radio)radio.checked=true;fs.querySelector('[data-bl-plan-input]').disabled=mode!=='sub'};
document.querySelectorAll('[data-bl-purchase]').forEach(fs=>{
 fs.addEventListener('change',e=>{if(e.target.name==='bl_purchase')setPurchase(fs,e.target.value)});
 setPurchase(fs,fs.querySelector('input[name=bl_purchase]:checked')?.value||'once');
});

/* "Are you sure you're giving up 15 %?" — at most until the shopper declines once per session. */
const keep=document.getElementById('bl-keep');let answer=null;
const declined=()=>ss.get('bl-keep-declined')==='1';
const ask=()=>new Promise(res=>{answer=res;keep.showModal();keep.querySelector('[data-bl-keep=sub]').focus()});
if(keep){
 keep.querySelectorAll('[data-bl-keep]').forEach(b=>b.addEventListener('click',()=>{const v=b.dataset.blKeep;keep.close();if(v==='once')ss.set('bl-keep-declined','1');if(answer)answer(v);answer=null}));
 keep.addEventListener('cancel',e=>{e.preventDefault();keep.close();if(answer)answer('abort');answer=null});
}
document.addEventListener('submit',async e=>{
 const form=e.target;if(!keep||!form.matches||!form.matches('.bl-product-form'))return;
 const fs=form.querySelector('[data-bl-purchase]');if(!fs)return;
 if(form.dataset.blBypass==='1'){delete form.dataset.blBypass;return}
 if(fs.querySelector('input[name=bl_purchase]:checked')?.value==='sub'||declined())return;
 e.preventDefault();e.stopImmediatePropagation();
 const choice=await ask();if(choice==='abort')return;
 if(choice==='sub')setPurchase(fs,'sub');
 form.dataset.blBypass='1';form.requestSubmit();
},true);

/* Cart: offer the subscription before checkout, convert eligible lines, then keep codes in sync. */
const cartForm=document.querySelector('.bl-cart form');
if(cartForm){
 cartForm.addEventListener('submit',async e=>{
  if(!e.submitter||!e.submitter.hasAttribute('data-bl-checkout'))return;
  e.preventDefault();const btn=e.submitter;btn.disabled=true;
  try{
   await fetch(root+'cart/update.js',{method:'POST',body:new FormData(cartForm),headers:{Accept:'application/json'}});
   const eligible=[...cartForm.querySelectorAll('[data-bl-line]')].filter(l=>l.dataset.blPlan&&l.dataset.blSub==='false');
   if(eligible.length&&keep&&!declined()){
    const choice=await ask();
    if(choice==='abort'){btn.disabled=false;return}
    if(choice==='sub'){
     for(const l of eligible.reverse()){
      const qty=Number(l.querySelector('input[name="updates[]"]')?.value||l.dataset.blQty);
      if(qty>0)await api('cart/change.js',{method:'POST',body:JSON.stringify({line:Number(l.dataset.blLine),quantity:qty,selling_plan:Number(l.dataset.blPlan)})});
     }
    }
   }
   await syncCodes().catch(()=>{});
  }catch{}
  location.href=root+'checkout';
 });
 const key='bl-codes-synced';
 syncCodes().then(r=>{if(r&&r.changed&&ss.get(key)!==r.cart.token){ss.set(key,r.cart.token);location.reload()}}).catch(()=>{});
}

/* Images with language versions (hero shots, ingredients, how-to): entries are "lang>url;...;*>fallback". */
const swapLangImages=()=>{
 const lang=(document.documentElement.dataset.blLang||document.documentElement.lang||'en').slice(0,2);
 document.querySelectorAll('[data-bl-lang-images]').forEach(el=>{
  const map={};el.dataset.blLangImages.split(';').forEach(p=>{const i=p.indexOf('>');if(i>0)map[p.slice(0,i)]=p.slice(i+1)});
  const url=map[lang]||map['*'];
  if(el.tagName==='IMG'){if(!url)return;const src=url+'&width='+(el.dataset.blWidth||720);if(el.getAttribute('src')!==src)el.setAttribute('src',src);return}
  const gallery=el.closest('.bl-gallery');
  if(!url){if(!el.hidden){el.hidden=true;gallery?.dispatchEvent(new Event('bl:images'))}return}
  const big=url+'&width=1200';if(el.dataset.blImage===big&&!el.hidden)return;
  const shown=el.hidden;el.hidden=false;el.dataset.blImage=big;const img=el.querySelector('img');if(img)img.src=url+'&width=180';
  if(shown)gallery?.dispatchEvent(new Event('bl:images'));
  const main=document.querySelector('[data-bl-main-image]');if(el.getAttribute('aria-pressed')==='true'&&main)main.src=big;
 });
};
swapLangImages();new MutationObserver(swapLangImages).observe(document.documentElement,{attributes:true,attributeFilter:['lang','data-bl-lang']});
document.addEventListener('shopify:section:load',swapLangImages);
window.blSyncCodes=syncCodes;

/* Live welcome signup: show and store the code, put it on the cart. */
const welcome=document.getElementById('bl-welcome');
if(welcome&&document.querySelector('[data-bl-signup-success]')){
 const code=welcome.dataset.code||'WELCOME10';ls.set('bl-welcome-code',code);
 const content=welcome.querySelector('[data-bl-signup-content]'),done=welcome.querySelector('[data-bl-signup-complete]');
 if(content&&done){content.hidden=true;done.hidden=false}
 fetch(root+'discount/'+encodeURIComponent(code)+'?redirect=%2Fcart.js').catch(()=>{}).finally(()=>syncCodes().catch(()=>{}));
}
welcome?.querySelector('[data-bl-copy-code]')?.addEventListener('click',async e=>{
 const btn=e.currentTarget;try{await navigator.clipboard.writeText(welcome.dataset.code)}catch{}
 btn.dataset.blT='welcome_copied';btn.textContent=t('welcome_copied');
});
})();
/* bl-sub end */
/* bl-pdp start */
(()=>{
const ctx=JSON.parse(document.getElementById('bl-context').textContent);
const dict=JSON.parse(document.getElementById('bl-translations').textContent);
const root=ctx.root.endsWith('/')?ctx.root:ctx.root+'/';
const t=k=>{const l=(document.documentElement.dataset.blLang||document.documentElement.lang||'en').slice(0,2);return (dict[l]||dict.en)[k]||dict.en[k]||k};
const phone=window.matchMedia('(max-width: 749px)');
let watcher=null,buyVisible=true;

/* Sticky bar: always on phones; on larger screens only once the buy button has scrolled away. */
const place=()=>{
 const bar=document.querySelector('[data-bl-pdp] [data-bl-sticky]');
 const on=!!bar&&(phone.matches||!buyVisible);
 if(bar)bar.classList.toggle('is-visible',on);
 document.documentElement.classList.toggle('bl-sticky-on',on);
};
const setup=pdp=>{
 if(watcher){watcher.disconnect();watcher=null}
 buyVisible=true;
 const anchor=pdp&&(pdp.querySelector('.bl-buy-row')||pdp.querySelector('.bl-coming'));
 if(anchor&&'IntersectionObserver' in window){
  watcher=new IntersectionObserver(([entry])=>{buyVisible=entry.isIntersecting;place()});
  watcher.observe(anchor);
 }else buyVisible=false;
 place();
};
phone.addEventListener?phone.addEventListener('change',place):phone.addListener(place);

const setCount=n=>{document.querySelectorAll('[data-bl-sticky]').forEach(bar=>bar.dataset.count=String(n));document.querySelectorAll('[data-bl-sticky-count]').forEach(el=>el.textContent=n)};
const goCheckout=async()=>{try{if(window.blSyncCodes)await window.blSyncCodes()}catch{}location.href=root+'checkout'};

document.addEventListener('click',e=>{
 const add=e.target.closest&&e.target.closest('[data-bl-sticky-add]');
 if(add){const form=add.closest('[data-bl-pdp]')?.querySelector('.bl-product-form');if(form&&!add.disabled)form.requestSubmit();return}
 const go=e.target.closest&&e.target.closest('[data-bl-sticky-checkout]');
 if(go){
  const bar=go.closest('[data-bl-sticky]');
  if(Number(bar.dataset.count||0)>0){bar.classList.add('is-busy');goCheckout();return}
  const form=go.closest('[data-bl-pdp]')?.querySelector('.bl-product-form');
  if(form){form.dataset.blThen='checkout';form.requestSubmit()}
 }
});
document.addEventListener('bl:adding',e=>{
 const bar=e.target.closest('[data-bl-pdp]')?.querySelector('[data-bl-sticky]');if(!bar)return;
 bar.classList.add('is-busy');const label=bar.querySelector('.bl-sticky-label');if(label)label.textContent=t('adding');
});
document.addEventListener('bl:added',e=>{
 const form=e.target,bar=form.closest('[data-bl-pdp]')?.querySelector('[data-bl-sticky]');
 setCount(e.detail?.cart?.item_count||0);
 if(form.dataset.blThen==='checkout'){delete form.dataset.blThen;goCheckout();return}
 if(!bar)return;
 bar.classList.remove('is-busy');bar.classList.add('is-added');
 const label=bar.querySelector('.bl-sticky-label');if(label)label.textContent=t('added_short');
 clearTimeout(bar._blTimer);bar._blTimer=setTimeout(()=>{bar.classList.remove('is-added');if(label)label.textContent=t('add')},1800);
});
document.addEventListener('bl:add-error',e=>{
 const form=e.target;delete form.dataset.blThen;
 const bar=form.closest('[data-bl-pdp]')?.querySelector('[data-bl-sticky]');if(!bar)return;
 bar.classList.remove('is-busy');const label=bar.querySelector('.bl-sticky-label');if(label)label.textContent=t('add');
});

/* Formula picker: swap the whole product section in place (Section Rendering API), keep the URL in sync. */
const cache=new Map();
const sectionUrl=href=>{const u=new URL(href,location.origin);u.searchParams.delete('bl_lang');u.searchParams.set('section_id','bl-product');return u.toString()};
const fetchSection=href=>{
 const key=sectionUrl(href);
 if(!cache.has(key))cache.set(key,fetch(key,{credentials:'same-origin'}).then(r=>{if(!r.ok)throw new Error('section');return r.text()}).catch(err=>{cache.delete(key);throw err}));
 return cache.get(key);
};
const prefetch=e=>{const link=e.target.closest&&e.target.closest('[data-bl-pdp] .bl-option-links a[data-bl-option]:not(.is-active)');if(link)fetchSection(link.href).catch(()=>{})};
document.addEventListener('pointerover',prefetch,{passive:true});
document.addEventListener('touchstart',prefetch,{passive:true});
document.addEventListener('focusin',prefetch);

document.addEventListener('click',async e=>{
 const link=e.target.closest&&e.target.closest('[data-bl-pdp] .bl-option-links a[data-bl-option]');
 if(!link||e.defaultPrevented||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey||e.button>0)return;
 const pdp=link.closest('[data-bl-pdp]');
 e.preventDefault();
 if(link.classList.contains('is-active'))return;
 const row=link.closest('.bl-option-links'),top=row.getBoundingClientRect().top;
 row.querySelectorAll('a[data-bl-option]').forEach(a=>{a.classList.toggle('is-active',a===link);a.toggleAttribute('aria-current',a===link)});
 pdp.setAttribute('aria-busy','true');
 try{
  const html=await fetchSection(link.href);
  const next=new DOMParser().parseFromString(html,'text/html').querySelector('[data-bl-pdp]');
  if(!next)throw new Error('pdp');
  const fresh=document.importNode(next,true);
  /* show the new product photo straight away: wait (briefly) for it to load before swapping */
  const photo=fresh.querySelector('[data-bl-main-image]');
  if(photo&&photo.src)await Promise.race([new Promise(done=>{const img=new Image();img.onload=img.onerror=done;img.src=photo.src}),new Promise(done=>setTimeout(done,700))]);
  pdp.replaceWith(fresh);
  const url=new URL(link.href,location.origin);url.searchParams.delete('bl_lang');url.searchParams.delete('section_id');
  history.replaceState(history.state,'',url.pathname+url.search);
  fresh.dispatchEvent(new CustomEvent('shopify:section:load',{bubbles:true,detail:{sectionId:'bl-product'}}));
  setup(fresh);
  const nextRow=fresh.querySelector('.bl-option-links');
  if(nextRow){const shift=nextRow.getBoundingClientRect().top-top;if(Math.abs(shift)>2)window.scrollBy(0,shift)}
  try{window.jdgm&&window.jdgm.initializeWidgets&&window.jdgm.initializeWidgets()}catch{}
 }catch{location.href=link.href}
});

setup(document.querySelector('[data-bl-pdp]'));
})();
/* bl-pdp end */
  } catch(e) { console.error(e); }
})();

})();
